import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-[#111827] px-3 py-2 text-base text-slate-200 shadow-sm",
        "transition-all duration-200",
        "placeholder:text-muted-foreground",
        "focus-visible:outline-none focus-visible:border-cyan-500/70",
        "focus-visible:shadow-[0_0_0_3px_rgba(34,211,238,0.12),0_0_12px_rgba(34,211,238,0.08)]",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
